/**
 * What the Safe Zone / WiFi badges do and don't say.
 *
 * The badges report configuration only — whether a Safe Zone was drawn and WiFi credentials
 * were entered. A green pair says the device is set up, not that the pet is standing inside
 * its Safe Zone or on that network this minute, and rescues have read the colours as live
 * status.
 *
 * Shown from two places, which is why the text lives here rather than beside either of them:
 * the Setup column header (see `buildDeviceColumns`) and the badges themselves in
 * {@link DeviceRow}. `DeviceSectionTable` imports `DeviceRow`, so a constant kept in the
 * former and read by the latter would close an import cycle.
 */
export const SETUP_STATUS_TOOLTIP =
  'Green means the Safe Zone and WiFi are set up. It does not mean pet is inside the Safe Zone or currently ' +
  'connected to WiFi. See Status for whether device is online.';

/**
 * The same text for a saved foster household, less its last sentence. The Foster Home
 * details modal has no Status field to send the reader to — that column belongs to the
 * device tables — and pointing at something that is not on screen is worse than stopping
 * one sentence early.
 */
export const SETUP_STATUS_TOOLTIP_HOME =
  'Green means the Safe Zone and WiFi are set up. It does not mean pet is inside the Safe Zone or currently ' +
  'connected to WiFi.';
